import { FC } from "react"
import { RolesSuccess } from "../../../../module/settings/containers/roles/success"

export const RolesSuccessPage: FC = () => <RolesSuccess />
